import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, InputAdornment, Tooltip } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import AppDialog from "../../../components/Common/AppDialog";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import CheckBox from "../../../components/Form/CheckBox";
import CustomButton from "../../../components/Form/CustomButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import RadioButtonGroup from "../../../components/Form/RadioButtonGroup";
import { getPointListing, getSettingListing, resetSettingState, updatePoint, updateSetting } from "../../../store/setting/actions";
import "../setting.css";


const GeneralSetting = ({ settingInput, settingUpdate, pointData, pointUpdate, formError, userPermission }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [confirmMaintenanceOpen, setConfirmMaintenanceOpen] = useState(false);
    const [error, setError] = useState();
    const [pointValues, setPointValues] = useState();
    const [settingInputList, setSettingInputList] = useState();
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [editable, setEditable] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("edit-setting") && setEditable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        dispatch(resetSettingState());
        initData();

        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
    }, [])

    useEffect(() => {
        if (formError) {
            setError(formError);
        }
        setIsLoading(false);
    }, [formError])

    useEffect(() => {
        if (settingInput?.data?.length > 0) {
            setSettingInputList(settingInput.data);
        }
    }, [settingInput])

    useEffect(() => {
        if (pointData?.data?.length > 0) {
            let value = {
                dollar: pointData.data[0]?.dollar || '0',
                point: pointData.data[0]?.point || '0',
                point_expiry_period: pointData.data[0]?.point_expiry_period || '0'
            }
            setPointValues(value);
        }
    }, [pointData])

    useEffect(() => {

        if (settingUpdate?.code && pointUpdate?.code) {

            if (settingUpdate?.code === 'success' && pointUpdate?.code === 'success') {
                setNotification({
                    open: true,
                    msg: 'Setting updated successfully',
                    type: 'success'
                })
                dispatch(resetSettingState());
                initData();
            } else if (settingUpdate?.code === 'success' && pointUpdate?.code !== 'success') {
                setNotification({
                    open: true,
                    msg: 'Setting updated successfully but points setting failed',
                    type: 'error'
                })
                // dispatch(resetSettingState());
                // initData();
            } else if (settingUpdate?.code !== 'success' && pointUpdate?.code === 'success') {
                setNotification({
                    open: true,
                    msg: 'Points setting updated successfully but setting failed',
                    type: 'error'
                })
                // dispatch(resetSettingState());
                // initData();
            }
            // setError value
            if (settingUpdate?.code === 'invalid_field') {
                setError(settingUpdate?.errors);
            }
            if (pointUpdate?.code === 'invalid_field') {
                setError(pointUpdate?.errors);
            }
        }
    }, [settingUpdate, pointUpdate])

    const initData = () => {
        dispatch(getSettingListing());
        dispatch(getPointListing());
    }

    const saveGeneralSetting = () => {
        let settingPayload = {
            settings: []
        }
        settingInputList.map(item => {
            settingPayload.settings.push({ value: item.value, key: item.key });
        })
        dispatch(updateSetting(settingPayload));
        dispatch(updatePoint({ id: pointData.data[0]?.id, data: pointValues }));
    }

    const handleValueChange = (obj, field, val, setDataObj, index) => {
        if (obj['key'] === 'system_status' && val == '0') {
            setConfirmMaintenanceOpen(true);
        } else {
            setDataObj(prevState => {
                const newState = [...prevState];
                newState[index] = { ...newState[index], [field]: val };
                return newState;
            });
        }
    }

    const maintenanceModeModal = () => {
        return (
            <AppDialog
                open={confirmMaintenanceOpen}
                close={() => setConfirmMaintenanceOpen(false)}
                titleIcon={'warning'}
                title={'Confirm maintenance mode'}
                positivePress={() => {
                    const index = settingInputList.findIndex(item => item.key === 'system_status');
                    if (index !== -1) {
                        setSettingInputList(prevState => {
                            const newState = [...prevState];
                            newState[index] = { ...newState[index], value: '0' };
                            return newState;
                        });
                    }
                    setConfirmMaintenanceOpen(false);
                }}
                positiveTitle={'Save'}
                positiveButtonStyle={{ width: '100%' }}
                negativePress={() => setConfirmMaintenanceOpen(false)}
                negativeTitle={'Back'}
                negativeButtonStyle={{ backgroundColor: 'white', border: '1px solid #D5D7DA', width: '100%' }}
                width={'45%'}
            >
                <div className="mb-1" style={{ fontFamily: 'Manrope-SemiBold' }}>Are you sure to switch the system into maintenance mode?</div>
                <div>
                    Switching the system into maintenance mode will make it inaccessible to users, and any ongoing activities may be interrupted. Please ensure all critical tasks are completed before proceeding.
                </div>
            </AppDialog>
        )
    }
    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    <CustomButton
                        title={'Save Changes'}
                        press={() => saveGeneralSetting()}
                        height={40}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        width={'100%'}
                    />
                </div>
            }
            <div className="page-content">
                <LoadingDialog open={loading || !settingInputList} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        title="General"
                        backRoute={'/settings'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: "General", link: "#" },
                        ]}
                    >
                        {
                            editable && width > 425 &&
                            <CustomButton
                                title={'Save Changes'}
                                press={() => saveGeneralSetting()}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />
                        }
                    </Breadcrumb>
                    <Card className="p-3">
                        <CardBody>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} pb={3}>
                                    <div className="setting-form-section-header">SYSTEM</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        {
                                            settingInput && settingInputList && settingInputList.map((item, index) => {
                                                const selection = item?.selection;
                                                let selectionList = [];
                                                selection && Object.entries(selection).map(([key, value]) =>
                                                    selectionList.push({ value: parseInt(key), label: value })
                                                );
                                                selectionList?.length > 0 && selectionList.sort((a, b) => b.value - a.value);
                                                return (
                                                    <Grid item xs={12}>
                                                        {item.type === 'radio' ?
                                                            <RadioButtonGroup
                                                                title={<>{item?.title} <Tooltip title={item?.description} placement="top"><i className="ri-information-line" /></Tooltip></>}
                                                                value={item?.value}
                                                                data={selectionList || []}
                                                                setValue={(e) => handleValueChange(item, 'value', e, setSettingInputList, index)}
                                                                name={item?.key} /> :
                                                            item.type === 'text' || item.type === 'textarea' ?
                                                                <CustomTextField
                                                                    title={item?.title}
                                                                    values={item?.value || ''}
                                                                    placeholder={item?.title}
                                                                    onChange={(e) => handleValueChange(item, 'value', e, setSettingInputList, index)}
                                                                    multiline={item.type === 'textarea'}
                                                                    rows={4}
                                                                /> :
                                                                item.type === 'select' ?
                                                                    <CustomSelect
                                                                        title={item?.title}
                                                                        values={item?.value || '-1'}
                                                                        onChange={(e) => handleValueChange(item, 'value', e, setSettingInputList, index)}
                                                                        placeholder={item?.title}
                                                                        data={item?.selection}
                                                                    /> :
                                                                    <CheckBox
                                                                        label={item?.title}
                                                                        values={item?.value}
                                                                        onChange={(e) => handleValueChange(item, 'value', e.target.checked, setSettingInputList, index)}
                                                                    />
                                                        }
                                                        {item?.key === "bypass_ip_address" && <div className="setting-desc">
                                                            Please separate multiple IP addresses with a comma. Any IPs given here will bypass the maintenance page.
                                                        </div>}
                                                        {error && <FormHelperText sx={{ color: "red" }}>{error?.[`settings.${index}.value`] || ""}</FormHelperText>}
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                    <div className="setting-form-section-header mt-5">POINTS SETTING</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} className="label-title">
                                            <div>Default points assigned</div>
                                            <div className="d-flex align-items-center">
                                                <div style={{ marginRight: 10, minWidth: 55 }}>For each</div>
                                                <CustomTextField
                                                    values={pointValues?.dollar || ''}
                                                    width={'275px'}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">S$</InputAdornment>,
                                                    }}
                                                    onChange={(e) => setPointValues((prevValues) => ({
                                                        ...prevValues,
                                                        dollar: e
                                                    }))}
                                                />
                                                <div className="mx-2">assign</div>
                                                <CustomTextField
                                                    values={pointValues?.point || ''}
                                                    placeholder={'0'}
                                                    width={'275px'}
                                                    onChange={(e) => setPointValues((prevValues) => ({
                                                        ...prevValues,
                                                        point: e
                                                    }))}
                                                />
                                                <div className="mx-2">points</div>
                                            </div>
                                            <div className="setting-desc">Set how many points will be earned based on the order value.</div>
                                            {error?.dollar && <FormHelperText sx={{ color: "red" }}>{error?.dollar?.[0]}</FormHelperText>}
                                        </Grid>
                                        <Grid item xs={12} className="label-title mt-2">
                                            <div>Points expiry period</div>
                                            <div className="d-flex align-items-center">
                                                <CustomTextField
                                                    values={pointValues?.point_expiry_period || ''}
                                                    placeholder={'0'}
                                                    type={'number'}
                                                    width={'250px'}
                                                    onChange={(e) => setPointValues((prevValues) => ({
                                                        ...prevValues,
                                                        point_expiry_period: e
                                                    }))}
                                                />
                                                <div className="mx-2">days</div>
                                            </div>
                                            <div className="setting-desc"> Specify how long points remain valid after they are earned.</div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardBody>
                    </Card>
                    {maintenanceModeModal()}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Setting, Login }) {
    return {
        settingInput: Setting.settingListing.data,
        settingUpdate: Setting.updateSetting,
        pointData: Setting.pointListing.data,
        pointUpdate: Setting.updatePoint,
        formError: Setting.error,
        userPermission: Login.permissionArry,

    };
}

export default connect(mapStateToProps)(GeneralSetting);